import React, { useEffect } from "react";
import { ExclamationCircleIcon, ExclamationTriangleIcon, InfoIcon, RetryIcon } from "@fluentui/react-icons-northstar";
import { Button, Flex } from "@fluentui/react-northstar";
import { useAuth } from "../../contexts/authContext";

export interface IAlertProps {
    type: "info" | "warning" | "error";
    children: any;
    authIssue?: boolean;
}

const Alert: React.FunctionComponent<IAlertProps> = ({ children, type, authIssue }) => {
    const { state: authState, refreshToken } = useAuth();
    const { authenticating } = authState;

    let color: string;
    let icon: JSX.Element;
    const style = { paddingRight: "5px" };

    useEffect(() => {
        if (type === "error") {
            const elem = document.getElementById("ErrorAlert");
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [type]);

    switch (type) {
        case "warning": color = "#FFA500"; icon = (<ExclamationCircleIcon size="small" style={style} />); break;
        case "error": color = "#C4314B"; icon = (<ExclamationTriangleIcon size="small" style={style} />); break;
        default: color = "#949391"; icon = (<InfoIcon size="small" outline style={style} />); break;
    }

    return (
        <Flex
            id={type === "error" ? "ErrorAlert" : undefined}
            vAlign="center"
            style={{
                backgroundColor: `${color}20`,
                border: `1px solid ${color}`,
                borderRadius: "2px",
                padding: "5px 10px"
            }}>
            {icon} <small>{children}</small>
            {authIssue &&
                <Button
                    content="Aktualizovat"
                    inverted
                    icon={<RetryIcon />}
                    size="small"
                    disabled={authenticating}
                    onClick={() => refreshToken()}
                    style={{ marginLeft: "5px" }}
                />
            }
        </Flex>
    );
};

export default Alert;
